// extracted by mini-css-extract-plugin
module.exports = {"statusTag":"AvailableInPlan_statusTag__cBHoH","unavailable":"AvailableInPlan_unavailable__nCQzJ"};